<!-- //
变量表单添加
@auth xuyd
@date 2024-05-03
//-->
<template>
  <el-dialog
      class="dialog-container"
      :title="title"
      :visible.sync="visible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="true"
      :fullscreen="debugMode"
      top="10vh"
      width="900px">
    <el-form @submit.native.prevent ref="refForm" :model="form" :rules="rules" size="small" label-width="100px"
             class="form" :style="formHeightClass">
      <el-row class="flex-row height100">
        <el-col :span="debugMode ? 12 : 24" class="flex-column height100">
          <el-form-item prop="variableName" label="变量名">
            <el-input v-model="form.variableName" clearable :disabled="viewMode" />
          </el-form-item>
          <el-form-item prop="variableDesc" label="描述">
            <el-input type="textarea" placeholder="接口描述"
                      v-model="form.variableDesc"
                      maxlength="255"
                      :autosize="{ minRows: 3, maxRows: 6}"
                      clearable
                      :disabled="viewMode"
                      style="width: 100%"
                      show-word-limit/>
          </el-form-item>
          <el-form-item prop="variableValue" label="变量值" class="form-item-editor">
            <monacoEditor v-model="form.variableValue" :options="codeOptions" :disabled="viewMode"/>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="debugMode" class="flex-column height100">
          <el-form-item prop="debugParams" label="调试入参" v-if="debugMode">
            <div class="title flex-row flex-halign-between">
              <el-button type="danger" size="mini" class="button"
                         @click="handleImportFromVariable">→从变量值导入参数←</el-button>
            </div>
            <monacoEditor v-model="form.debugParams" :options="reqParamJsonOptions" style="height: 150px;"/>
          </el-form-item>
          <el-form-item label="" v-if="debugMode">
            <el-button type="primary" size="small" style="width: 100%" @click="handleDebug">执 行</el-button>
          </el-form-item>
          <el-form-item prop="respResult" label="调试结果" v-if="debugMode" class="form-item-result-editor">
            <monacoEditor v-model="respResult" :options="resultOptions"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="hideModal">取 消</el-button>
      <el-button type="primary" size="small" v-if="!viewMode" @click="handleShowDebug">{{ debugName }}</el-button>
      <el-button type="primary" size="small" v-if="!viewMode" @click="handleOk" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import variableApi from '@/api/sys/sysVariable.api.js';
import monacoEditor from '@/components/Editor/monacoEditor.vue'

export default {
  name: 'ViewVariableDetail',
  components: {monacoEditor},
  dictTypes: [],
  data() {
    return {
      loading: false,
      validateLoading: false,
      visible: false,
      title: '新建变量',

      switchMode: true,
      debugMode: false,
      debugName: '打开调试',
      respResult: '',
      reqParamJsonOptions: {languageGroup: 'json', language: 'json', autoFormat: true, minimap: {enabled: false}},
      resultOptions: {languageGroup: 'shell', language: 'shell', autoFormat: true, readOnly: true},
      opts: {
        mode: null,
      },
      form: {
        variableName: null,
        variableValue: null,
        variableDesc: null,
        status: 1,
        debugParams: '',
      },
      rules: {
        variableName: [{required: true, message: "请输入参数名", trigger: 'blur'}],
      },
    }
  },
  computed: {
    editMode() {
      return this.opts.mode === 2;
    },
    viewMode() {
      return this.opts.mode === 3;
    },
    codeOptions() {
      return {languageGroup: 'shell', language: 'shell', minimap: {enabled: false}, readOnly: this.viewMode}
    },
    formHeightClass() {
      if (this.debugMode) {
        return "height: calc(100vh - 54px - 62px - 60px)";
      } else {
        return "height: calc(100vh - 20vh - 54px - 62px - 60px)";
      }
    },
  },
  methods: {
    showModal({data, mode, title, onOk}) {
      let that = this;
      this.dialogShow({
        data: data,
        mode: mode,
        title: title,
        onOk(data) {
          let promise = onOk && onOk(data);
          if (promise) {
            promise.then(() => {
              that.hideModal();
            }).catch(err => {
              console.log(err)
            })
          }
        },
      })
    },
    dialogShow(opts) {
      // console.log("===========>", opts)
      this.opts.mode = opts.mode
      this.opts.onOk = opts.onOk
      this.opts.onCancel = opts.onCancel
      this.title = opts.title
      if (!opts.data) {
        opts.data = {};
      }
      this.form = this.$util.mergeObject(this.form, opts.data)
      this.respResult = '';
      this.visible = true;
    },

    hideModal() {
      this.visible = false;
      this.$refs["refForm"].clearValidate();
      this.$refs["refForm"].resetFields();
    },

    /**
     * 点击确定
     */
    handleOk() {
      let data = {...this.form};
      this.$refs.refForm.validate(valid => {
        if (valid) {
          this.loading = true;
          return variableApi.saveVar(data).then(resp => {
            this.loading = false;
            this.$modal.msgSuccess("保存成功")
            this.opts.onOk(resp.data);
            this.hideModal();
          }).catch(() => {
            this.loading = false;
          });
        }
      })
    },
    // 打开调试面板
    handleShowDebug() {
      this.debugMode = !this.debugMode;
      this.debugName = this.debugMode ? '关闭调试' : '打开调试';
      this.respResult = '';
    },
    // 调试
    handleDebug() {
      return variableApi.debugShellCmd(this.form).then(resp => {
        this.respResult = resp.data;
      })
    },
    // 从变量内容导入
    handleImportFromVariable() {
      let regex = /\${(.*?)}/g;
      let c = this.form.variableValue;
      let matches = [...c.matchAll(regex)];
      if (matches) {
        let params = {};
        matches.forEach(item => {params[item[1]] = ""});
        this.form.debugParams = JSON.stringify(params);
      }
    },
  }
}
</script>

<style lang="less" scoped>

.height100 {
  height: 100%;
}

.form {
  overflow: auto;
  padding-right: 50px;

  .title {
    padding: 2px 10px;
    background-color: #1e1e1e;
    color: #EEEEEE;
    border-bottom: 1px solid #666666;

    .button {
      color: #EEEEEE;
    }
  }

  .form-item-editor {
    flex: 1;
    display: block;

    :deep(.el-form-item__content) {
      height: calc(100% - 15px);
    }
  }

  .form-item-result-editor {
    flex: 1;
    display: block;

    :deep(.el-form-item__content) {
      height: calc(100% - 15px);
    }
  }
}
</style>
